import { render } from "./SearchUser.vue?vue&type=template&id=443d55c0"
import script from "./SearchUser.vue?vue&type=script&lang=js"
export * from "./SearchUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__